// @ts-check
import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import Button from '@liquidweb-dev/undercurrent/Button';
import DrawerReboot from 'components/DrawerReboot';
import ActionsContainer from './ActionsContainer';
import ActionsMenu from './ActionsMenu';
import canReboot from './canReboot';
import isCloudMetal from './isCloudMetal';

/** @param {import('modules/queries/asset/useDetails').AssetDetails} props */
const ActionsContent = (props) => {
	const {
		capabilities,
		powerStatus,
		status,
		uniq_id: uniqId,
		isPrivateParent,
		isPrismManaged,
		type,
	} = props;

	const [isRebootDrawerOpen, setIsRebootDrawerOpen] = useState(false);

	const isActive = status === 'Active';
	/**
	 * This button is the only reboot the detail page offers: the actions menu's
	 * own reboot item renders for the servers list only. So it carries the same
	 * gates the list item does, and `?reboot=1` below it inherits them.
	 *
	 * A Prism-managed asset reboots from Prism Central, not from the portal.
	 * Recognition by product code fails open, so an unrecognized Nutanix
	 * container reaches this page instead of the Nutanix one, and this gate is
	 * what keeps the button off it.
	 *
	 * A Cloud Metal server is asked to reboot through the actions menu's
	 * "Request reboot" item instead, so the button would duplicate it.
	 */
	const showReboot =
		!isPrismManaged &&
		canReboot(capabilities) &&
		!isPrivateParent &&
		!isCloudMetal(type) &&
		powerStatus !== 'unknown';
	const rebootDisabled = !isActive || powerStatus !== 'on';

	const location = useLocation();
	const history = useHistory();

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		if (!params.has('reboot')) return;
		if (showReboot && !rebootDisabled) {
			setIsRebootDrawerOpen(true);
		}
		params.delete('reboot');
		history.replace({ search: params.toString() });
	}, [location.search, showReboot, rebootDisabled, history]);

	return (
		<ActionsContainer>
			{showReboot && (
				<Button
					variant="primary"
					size="large"
					disabled={rebootDisabled}
					onClick={() => setIsRebootDrawerOpen(true)}
					sx={{ width: { xs: '100%', md: 'auto' } }}
				>
					Reboot
				</Button>
			)}

			<ActionsMenu {...props} intent="serverInterior" />

			<DrawerReboot
				open={isRebootDrawerOpen}
				onClose={() => setIsRebootDrawerOpen(false)}
				uniqId={uniqId}
			/>
		</ActionsContainer>
	);
};

export default ActionsContent;
